module.exports = __webpack_public_path__ + "static/media/trash.0d96f71f.svg";